export type IResetViewImageModal = (modal: HTMLElement) => void;

export function _resetViewImageModal(modal: HTMLElement): void {
  // Modal Elements
  const $modal = $(modal);
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalImgElm = $modal.find('.modal-body .full-image');
  const $modalLoading = $modal.find('.loading');
  const $imageContainer = $modal.find('.image-container');
  // Empty elements
  $modalTitle.html('');
  $modalLoading.removeClass('hide').attr('aria-hidden', 'false');
  $imageContainer.addClass('hide').attr('aria-hidden', 'true');
  $modalImgElm.attr({
    alt: '',
    src: '',
  });
}
